module.exports = __webpack_public_path__ + "static/img/shipin-Edward.6eea27b9.png";